import { memo, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { useTheme } from "../../contexts/ThemeContext/ThemeContext";
import NavHeader from "../NavHeader";
import styles from "./index.module.scss";
import LoaderImg from "../../assets/images/videoLoader.gif";
import close from "../../assets/images/close.png";
import OverlayCard from "./partials/OverlayCard";
// import { VideosData } from "./videoData";
import TabComponent from "../TabsComponent";
// import MyDropdown from "../Tags/Dropdown";
import EpisodesTab from "./partials/EpisodesTab";
import ContactFooter from "../ContactFooter";
import SpeakersCards from "./partials/SpeakersCards";
import DetailsTab from "./partials/DetailsTab";
import NewsAndTranscript from "./partials/NewsAndTranscript";
import OverlayCardMob from "./partials/OverlayCardMob";
import NotesManager from "../../Managers/Users/Notes";
import SpeakerManager from "../../Managers/Speakers";
import VideoManager from "../../Managers/Video";
import DetailManager from "../../Managers/Details";
import {
  ContentType,
  ContentType2,
  ExclusiveType,
  VideoType,
} from "../../AppConstants/TypeConstants";
import MuxVideoPlayer from "../MuxVideoPlayer/MuxVideoPlayer";
import { MediaMetadataContext } from "../../contexts/MediaMetaDataContext/MediaMetadataContextProvider";
import { UserContext } from "../../contexts/UserContext/UserContextProvider";
import { Box, ContainerBox, Line, Shimmer } from "../ShimmerEffect";
import { isLandscape, isMobileDevice } from "../../utils/getPlatformInfo";
// import { useScrollHandler } from "../../hooks/useScroll";
import { VideoPlayerContext } from "../../contexts/VideoPlayerContext/VideoPlayerContextProvider";
import { THEME } from "../../AppConstants/ThemeConstant";
import InviteModal from "../InviteModal/InviteModal";
import {
  INVITEYOURFRIEND_EVENT_BTN,
  VIDEO_CLICK,
  VIDEO_NOTE_BTN_CLICK,
  VIDEO_PLAY,
  VIDEO_SHARE_BTN_CLICK,
  VIDEO_TABS_CLICK,
  VIDEO_WATCH_LATER_BTN_CLICK,
} from "../../AppConstants/AnalyticsEventName";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import { authContext } from "../../contexts/AuthContext/AuthContextProvider";
import { ASCENDING, TIMESTAMP } from "../../AppConstants/SortConstants";
import {
  algoliaCustomEvents,
  AlgoliaEventType,
  algoliaIndices,
} from "../../AppConstants/AlgoliaSearchConstants";
import { VIDEO_PAGE_ROUTE } from "../../AppConstants/Routes";
import {
  isHtmlContentEmpty,
  showToast,
  updateSearchParamsForSeason,
} from "../../utils/common.utils";
import ChaptersManager from "../../Managers/Video/Chapters";
import VideoOverlayDesktop from "./partials/VideoOverlayDesktop";
import WatchLaterManager from "../../Managers/Users/WatchLater";
import {
  ADD_TO_WATCH_LATER_EVENT,
  FALLBACK_PAGE_EVENT,
  SUB_TAB_CLICK_EVENT,
} from "../../Clevertap/EventNames.ts";
import {
  defaultNotAvailableText,
  getStandaloneVideoData,
  getSubtabData,
} from "../../Clevertap/EventHandler.ts";
import { globalsAPI } from "../../apis/globalsAPI.js";
import { VIDEO_COLLECTION } from "../../AppConstants/CollectionConstants.js";
import PrivateVideoVerificationModal from "../PrivateContentSection/PrivateVideoVerificationModal";
const initialVerificationModal = {
    data: null,
    open: false,
  };
const VideoDetails = () => {
      const [verificationModal, setVerificationModal] = useState(
        initialVerificationModal
      );
  const _currURL = window.location.href;
  const _currpathName = window.location.pathname;
  const is_LN_Route = false; // _currpathName.startsWith("/ln/video/");
  const LN_PREPEND = is_LN_Route ? "/ln" : "";
  const { user, userMetadata } = useContext(UserContext);
  const {
    updateMultipleState,
    handleInitialCancelled,
    toggleSignInbtn,
    cancelled,
    state: newAuthState,
  } = useContext(authContext);
  const muxVideoRef = useRef("");
  // const scrollValue = useScrollHandler(0);
  const [allNotes, setAllNotes] = useState([]);
  const [allChapters, setAllChapters] = useState(null);

  // const history = useHistory();

  // const { videoId, season = 0 } = history.query;
  const { mediaMetadata, updateMediaMetadata } =
    useContext(MediaMetadataContext);
  const { isFullScreen } = useContext(VideoPlayerContext);
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);

  const { videoId } = useParams();
  const { pathname, search = "", hash = "", state = "" } = useLocation();
  const history = useHistory();

  const { isDark } = useTheme();
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

  const tabId = () => {
    switch (hash) {
      case "#speakers":
        return 0;
      case "#details":
        return 1;
      case "#related videos":
        return 2;
      default:
        return 0;
    }
  };
  const tab = tabId();

  const [showPlayer, setShowPlayer] = useState(true);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [restrictedVideo, setRestrictedVideo] = useState(false);

  const { SearchEvent } = useContext(AnalyticsContext);

  const [videoDetails, setVideoDetails] = useState(null);

  const [videoData, setVideoData] = useState(null);
  const [isPremiumVideo, setIsPremiumVideo] = useState({
    type: false,
    modalType: "",
  });

  const [videoSpeakers, setVideoSpeakers] = useState(null);
  const [isvideoLoading, setIsVideoLoading] = useState(true);

  const [selectedTab, setSelectedTab] = useState(0);

  const [videoRecentVideo, setVideoRecentVideo] = useState([]);
  const [videoToggle, toggleVideoToggle] = useState(false);

  const [currentVideoShare, setCurrentVideoShare] = useState(videoData);
  const [isWatchLaterVideo, setIsVideoWatchLater] = useState(false);

  const isAnalyticsFired = useRef(null);

  useEffect(() => {
    if (user && videoData && !isAnalyticsFired.current) {
      addClickAnalytics(VIDEO_PLAY);
      isAnalyticsFired.current = true;
    }
  }, [user, videoData]);

  useEffect(() => {
    setCurrentVideoShare(videoData);
  }, [videoData]);

  useEffect(() => {
    if (videoToggle) {
      toggleVideoToggle(false);
    }
  }, [videoToggle]);

  useEffect(() => {
    if (videoData && user && Object.values(videoData).length > 0) {
      let idMain = videoData.tags.length > 0 ? videoData.tags[0] : "";

      getRelatedVideos(idMain).then((res) => {
        let fileterData = res.filter((item) => {
          return item.id !== videoId;
        });

        setVideoRecentVideo(fileterData);
      });
    }
  }, [videoData, user]);

  // useEffect(() => {
  //   if (user) {
  //     if (is_LN_Route) {
  //       let modifiedURL = _currURL.replace("/ln/video/", "/video/");
  //       window.open(modifiedURL, "_self");
  //     }
  //   } else {
  //     if (!is_LN_Route) {
  //       let modifiedURL = _currURL.replace("/video/", "/ln/video/");
  //       window.open(modifiedURL, "_self");
  //     }
  //   }
  // }, [user]);

  useEffect(() => {
    // if no user and login pop up appear then pause the video
    if (!user && newAuthState.showSignInModal) {
      togglePlayer();
    }
  }, [user, newAuthState.showSignInModal]);

  useEffect(() => {
    if (userMetadata && videoData) {
      let _curr = videoData;
      let watchableToggle =
        _curr.freeWatchableToggle !== undefined
          ? _curr.freeWatchableToggle
          : true;
      if (
        _curr.type === ExclusiveType.PREMIUM ||
        _curr.type === ExclusiveType.EXCLUSIVE
      ) {
        if (_curr.type === ExclusiveType.PREMIUM) {
          handlePremiumVideoClick(watchableToggle);
        } else if (_curr.type === ExclusiveType.EXCLUSIVE) {
          handleExclusiveVideoClick(watchableToggle);
        }
      }
    }
  }, [userMetadata, videoData]);

  useEffect(() => {
    if (user) {
      SearchEvent(
        AlgoliaEventType.View,
        algoliaIndices.videos,
        algoliaCustomEvents.normalView,
        [videoId]
      );
    }

    // if (state && state.search && videoId) {
    //   SearchEvent(
    //     AlgoliaEventType.View,
    //     algoliaIndices.videos,
    //     algoliaCustomEvents.searchView,
    //     [videoId],
    //   );
    // } else {

    //   );
    // }
  }, [state, videoId]);

  useEffect(() => {
    handleInitialCancelled();
  }, []);

  useEffect(() => {
    if (user && videoId) {
      toggleVideoToggle(true);
      fetchData();
      fetchAllNotes();
      fetchWatchLater();
      fetchAllChapters();
    }
    return () => {
      NotesManager._get.removeNotesListener();
    };
  }, [user, videoId]);

  useEffect(() => {
    if (!user && videoId) {
      fetchDataWithOutUser();
      toggleVideoToggle(true);
    }
  }, [user, videoId]);

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);

  const getRelatedVideos = async (tag) => {
    let arr = [];
    if (tag) {
      let res = await VideoManager._get.getSortedVideos({
        tags: [tag],
        based_on: TIMESTAMP,
        order: ASCENDING,
      });
      arr = res.data;
    }
    return arr;
  };

  useEffect(() => {
    if (showInviteModal) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.position = "unset";
    }
    if (isSidePanelOpen && isMobileDevice) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.position = "unset";
    }
  }, [showInviteModal, isSidePanelOpen]);

  const fetchDataWithOutUser = async () => {
    try {
      const res = await globalsAPI.generateTempVideoToken({
        type: VIDEO_COLLECTION,
        id: videoId,
      });
      let video = res.data;

      if (!video) {
        handleFallBackEvents();
        history.replace({ pathname: VIDEO_PAGE_ROUTE, search: search });
      }

      // http://localhost:3000/series/series-l514piux/?season=1&ep=1#videos
      // http://localhost:3000/series/series-l514piux/?season=1&ep=4#videos
      if (
        video.videoType === ContentType.SERIES ||
        video.videoType === ContentType.TRAILER
      ) {
        let type =
          video.videoType === ContentType.SERIES
            ? "ep"
            : video.videoType === ContentType.TRAILER
            ? ContentType.TRAILER
            : "ep";

        history.replace({
          pathname: LN_PREPEND + `/series/${video.videoData.seriesId}`,
          search: updateSearchParamsForSeason(
            search,
            type,
            video.videoData.seasonIndex + 1,
            type === "trailer"
              ? video.videoData.trailerId
              : video.videoData.episodeId
          ),
          hash: `#videos`,
          state: state ? state : null,
        });
      }

      document.title = `${video.title} | Videos | Docflix – OTT platform for doctors`;

      setVideoData(video);
      handleVideoLoading(false);
    } catch (error) {
      handleFallBackEvents({ id: videoId });
      history.replace({ pathname: VIDEO_PAGE_ROUTE, search: search });
    }
  };

  const fetchData = async () => {
    try {
      let video = await VideoManager._get.getVideoById(videoId);
      if (!video) {
        handleFallBackEvents();
        history.replace({ pathname: VIDEO_PAGE_ROUTE, search: search });
      }

      // http://localhost:3000/series/series-l514piux/?season=1&ep=1#videos
      // http://localhost:3000/series/series-l514piux/?season=1&ep=4#videos
      if (
        video.videoType === ContentType.SERIES ||
        video.videoType === ContentType.TRAILER
      ) {
        let type =
          video.videoType === ContentType.SERIES
            ? "ep"
            : video.videoType === ContentType.TRAILER
            ? ContentType.TRAILER
            : "ep";

        history.replace({
          pathname: LN_PREPEND + `/series/${video.videoData.seriesId}`,
          search: updateSearchParamsForSeason(
            search,
            type,
            video.videoData.seasonIndex + 1,
            type === "trailer"
              ? video.videoData.trailerId
              : video.videoData.episodeId
          ),
          hash: `#videos`,
          state: state ? state : null,
        });
      }

      let _speakers = [];
      let details = null;

      // video speakers
      if (video.speakers && video.speakers.length > 0) {
        _speakers = await Promise.all(
          video.speakers.map(async (speaker) => {
            let res = await SpeakerManager._get.getSpeakerById(speaker);
            if (res) {
              return res;
            }
          })
        );
      }

      // video details
      if (video.detailsId) {
        let res = await DetailManager._get.getDetailById(video.detailsId);
        if (res) {
          details = res;
        }
      }
      // video tokens
      // if (video.sourceType === SourceType.SOURCE_MUX) {
      //   if (video.videoPolicy && video.videoPolicy === SignedType.SIGNED) {
      //     let res = await fetchVideoTokens(video.playbackid);
      //     video["tokens"] = res.data;
      //   }
      // }

      document.title = `${video.title} | Videos | Docflix – OTT platform for doctors`;

      setVideoDetails(details);

      const { playbackid = "", tokens = {} } = video || {};

      const populateData = () => {
        if (_speakers && _speakers.length > 0) {
          setSelectedTab(0);
        } else {
          setSelectedTab(1);
        }
        setVideoData(video);
        setVideoSpeakers(_speakers);
        // history.replace({
        //   pathname: LN_PREPEND +`/video/${videoId}`,
        //   hash: "speakers",
        // search:search
        // });
      };

      let img = new Image();
      img.onload = populateData;
      img.onerror = populateData;
      img.src = `https://image.mux.com/${playbackid}/thumbnail.jpg${
        tokens && tokens.thumbnailToken && tokens.thumbnailToken !== ""
          ? `?token=${tokens.thumbnailToken}`
          : ``
      }`;
    } catch (error) {
      handleFallBackEvents({ id: videoId });
      history.replace({ pathname: VIDEO_PAGE_ROUTE, search: search });
    }
  };

  const playNextEpisode = () => {
    changeRoute(videoRecentVideo[0]);
  };

  const handlePremium = (toggle, modalType) => {
    updateMultipleState({ cancelled: true });

    if (toggle) {
      setIsPremiumVideo({ type: true, modalType: modalType });
    } else {
      setRestrictedVideo(true);
      return updateMultipleState({ [modalType]: true });
    }
  };
  const changeRoute = (episode) => {
    if (episode.type && episode.type !== ExclusiveType.FREE) {
      if (
        episode.type === ExclusiveType.PREMIUM ||
        episode.type === ExclusiveType.EXCLUSIVE
      ) {
        if (episode.type === ExclusiveType.PREMIUM) {
          handlePremiumVideoClick(episode);
        } else if (episode.type === ExclusiveType.EXCLUSIVE) {
          handleExclusiveVideoClick();
        }
      }
    } else {
      SearchEvent(
        AlgoliaEventType.View,
        algoliaIndices.videos,
        algoliaCustomEvents.normalClick,
        [episode.id]
      );
      addClickAnalytics(VIDEO_CLICK);
      let goRoute = LN_PREPEND + `/video/${episode.id}`;
      history.push({ pathname: goRoute, search: search });
    }
  };

  const handlePremiumVideoClick = (toggle) => {
    if (
      userMetadata.current_plan &&
      (userMetadata.current_plan === ExclusiveType.PREMIUM ||
        userMetadata.current_plan === ExclusiveType.EXCLUSIVE)
    ) {
      setRestrictedVideo(false);
      setIsPremiumVideo(false);
      updateMultipleState({ cancelled: false });
    } else {
      handlePremium(toggle, "premiumFormModalStart");
      // setRestrictedVideo(true);
      // return updateMultipleState({ premiumFormModalStart: true });
    }
  };
  const handleExclusiveVideoClick = (toggle) => {
    // first check for premium
    if (
      userMetadata.current_plan &&
      userMetadata.current_plan === ExclusiveType.FREE
    ) {
      handlePremium(toggle, "premiumFormModalStart");
      // setRestrictedVideo(true);
      // return updateMultipleState({ premiumFormModalStart: true });
    } else if (
      userMetadata.current_plan &&
      userMetadata.current_plan !== ExclusiveType.EXCLUSIVE
    ) {
      handlePremium(toggle, "exclusiveFormModalStart");
      // setRestrictedVideo(true);
      // updateMultipleState({ exclusiveFormModalStart: true });
    } else {
      setRestrictedVideo(false);
      setIsPremiumVideo(false);
      updateMultipleState({ cancelled: false });
    }
  };

  const handleFallBackEvents = ({ id = "" } = {}) => {
    addCleverTapAnalytics(FALLBACK_PAGE_EVENT, {
      "Original Screen": "VideoDetail",
      "Fallback Screen": "Videos",
      "Content ID": id || defaultNotAvailableText,
      "Status Message": "Some unknown error",
    });
  };

  const fetchAllNotes = async () => {
    if (user) {
      NotesManager._get.attachNotesListener(videoId, user.uid, (res, err) => {
        if (err) {
          return;
        }
        setAllNotes(res);
      });
    }
  };

  const fetchWatchLater = async () => {
    if (user) {
      WatchLaterManager._get.getWatchLater(videoId, user.uid, (res, err) => {
        if (err) {
          return;
        }
        setIsVideoWatchLater(res);
      });
    }
  };

  const fetchAllChapters = async () => {
    if (!user) {
      return;
    }
    let chapters = await ChaptersManager._get.getAllChapters(videoId);
    if (chapters) {
      setAllChapters(chapters.content);
    }
  };

  const TABS = [
    {
      label: "Speakers",
      hideTab: !videoSpeakers || videoSpeakers.length <= 0,
      childComponent: () => {
        return videoSpeakers && <SpeakersCards speakersList={videoSpeakers} />;
      },
    },
    {
      label: "Details",
      hideTab: isHtmlContentEmpty(videoDetails?.content),
      childComponent: () => {
        return (
          <DetailsTab
            detailsData={videoDetails}
            videoData={videoData}
            allChapters={allChapters}
            seekTo={seekTo}
          />
        );
      },
    },

    {
      label: "Related Videos",
      hideTab: false,
      childComponent: () => {
        return (
          <EpisodesTab
            videoData={videoData}
            episodes={videoRecentVideo}
            setRestrictedVideo={setRestrictedVideo}
            handleInviteBtn={handleInviteBtn}
            setCurrentVideoShare={setCurrentVideoShare}
            addClickAnalytics={addClickAnalytics}
          />
        );
      },
    },
  ];

  const startWatchingBtn = () => {
    // if (!user) {
    //   toggleSignInbtn("showSignInModal", true);
    //   return;
    // }
    if (muxVideoRef.current) {
      if (muxVideoRef.current.paused) {
        muxVideoRef.current.play();
        setShowPlayer(true);
      } else {
        muxVideoRef.current.pause();
        setShowPlayer(false);
      }
    }
  };

  const togglePlayer = () => {
    if (muxVideoRef.current) {
      if (muxVideoRef.current.paused) {
        muxVideoRef.current.play();
        setShowPlayer(true);
      } else {
        muxVideoRef.current.pause();
        setShowPlayer(false);
      }
    }
  };

  const closeStartWatchingBtn = (videoDur, videoWatched, type) => {
    if (videoDur) {
      updateMediaMetadata(
        videoData.id,
        videoWatched,
        videoDur,
        ContentType.VIDEO
      );
    }
    if (type === "backbtn") {
      startWatchingBtn();
    }
  };
  const handleNoteBtn = () => {
    addGAWithUserInfo(VIDEO_NOTE_BTN_CLICK);
    if (!isSidePanelOpen && !muxVideoRef.current.paused) {
      muxVideoRef.current.pause();
    }
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  const handleWatchLaterBtn = async () => {
    addGAWithUserInfo(VIDEO_WATCH_LATER_BTN_CLICK);
    let isAdded = false;
    let pos = {
      targetId: videoId,
      userId: user.uid,
      type: ContentType.VIDEO,
      videoType: VideoType.VIDEO_STANDALONE,
      videoData: {},
    };
    if (isWatchLaterVideo) {
      isAdded = true;
      await WatchLaterManager._delete.deleteWatchLater(pos);
      setIsVideoWatchLater(false);
      showToast("Removed Successfully");
    } else {
      isAdded = false;
      await WatchLaterManager._post.createWatchLater(pos);
      setIsVideoWatchLater(true);
      showToast("Added Successfully");
    }
    addCleverTapAnalytics(ADD_TO_WATCH_LATER_EVENT, {
      Status: isAdded ? "Added" : "Removed",
      ...getStandaloneVideoData(state.currentEpisode),
    });
  };

  const handleInviteBtn = () => {
    addClickAnalytics(VIDEO_SHARE_BTN_CLICK);
    setShowInviteModal(true);
  };
  const handleInviteBtnClose = () => {
    setShowInviteModal(false);
  };

  const addClickAnalytics = (eventName) => {
    addGAWithUserInfo(eventName, { eventId: videoData.id });
  };
  const handleVideoLoading = (bool) => {
    setIsVideoLoading(bool);
  };
  const seekTo = (seconds) => {
    if (muxVideoRef.current) {
      muxVideoRef.current.currentTime = seconds;
      muxVideoRef.current.play();
    }
  };
  const { playbackid = "", tokens = {}, thumbnailUrl = "" } = videoData || {};

  const checkForPremium = (currentTime) => {
    if (
      isPremiumVideo.type &&
      videoData.freeWatchableDuration &&
      currentTime > videoData.freeWatchableDuration
    ) {
      setRestrictedVideo(true);
      updateMultipleState({ [isPremiumVideo.modalType]: true });
    }
  };
  const handleClosePrivateModal = useCallback(() => {
    setVerificationModal(initialVerificationModal);
    // handleCancelButton();
    return history?.goBack();
  }, []);

  const handleOpenPrivateModal = useCallback((item) => {
    setVerificationModal({ open: true, data: item });
  }, []);

  const handleVerifyButton = useCallback(() => {
    setVerificationModal(initialVerificationModal);
  }, []);
  useEffect(() => {
    // console.log(videoData);
    async function checkPrivateVideoUnlocked() {
      if (user && 
        !verificationModal.open && videoData &&
        videoData?.private === true
      ) {
          let isUnlocked=await VideoManager._get.checkVideoUnlockedForUser(user.uid,videoData.id);
        //   console.log("came here ",isUnlocked);
          if(!isUnlocked){
            let obj = {
              isUnlockedForUser: true,
              prerequisite: false,
              courseData: videoData,
              collection: VIDEO_COLLECTION,
            };
            handleOpenPrivateModal(obj);
        }
      }
    }
    checkPrivateVideoUnlocked();
  }, [user,videoData]);


  return verificationModal.open ? (
    <PrivateVideoVerificationModal
      collection={verificationModal?.data?.collection}
      verificationModal={verificationModal}
      handleClose={handleClosePrivateModal}
      handleVerifyButton={handleVerifyButton}
    />
  ) : (
 
    !restrictedVideo && (
      <div className={styles.videoPage}>
        <div
          className={
            isDark
              ? styles.headerBannerWrapper
              : styles.headerBannerWrapperLight
          }
        >
          <NavHeader
            scrollValue={30}
            defaultBg={"#000"}
            themeConstant
            nativeBack
          />
        </div>

        <div
          className={`${styles.playerSection} ${
            isFullScreen && styles.playerSectionFullScreen
          }`}
        >
          <div
            className={styles.videoSide}
            style={{ zIndex: isFullScreen && 9 }}
          >
            {videoData && !videoToggle && !newAuthState.showSignInModal && (
              <MuxVideoPlayer
                playNextEpisode={playNextEpisode}
                cancelled={cancelled}
                checkForPremium={checkForPremium}
                showPlayer={showPlayer}
                isSidePanelOpen={isSidePanelOpen}
                handleNoteBtn={handleNoteBtn}
                handleWatchLaterBtn={handleWatchLaterBtn}
                isWatchLaterVideo={isWatchLaterVideo}
                startingPoint={
                  mediaMetadata[videoData.id]
                    ? mediaMetadata[videoData.id].lastWatchTimestamp
                    : 0
                }
                closeStartWatchingBtn={closeStartWatchingBtn}
                videoData={{
                  ...videoData,
                  targetType: ContentType2["Standalone Video"],
                }}
                muxVideoRef={muxVideoRef}
                themeType={THEME.VIDEO_THEME}
                handleVideoLoading={handleVideoLoading}
                allNotes={allNotes}
                allChapters={allChapters}
              />
            )}
            {isvideoLoading && (
              <div className="videoLoader">
                <img loading="lazy" src={LoaderImg} alt="" height="100%" />
              </div>
            )}
            <Shimmer
              loading={!videoData}
              loadingComponent={
                <ContainerBox shimmer={isMobileDevice}>
                  <div className={styles.loaderWrapper}>
                    <div
                      style={{
                        alignSelf: "flex-end",
                        bottom: "20%",
                        position: "relative",
                      }}
                    >
                      <Box height={60} width={200} />
                      <Line
                        count={1}
                        sameWidth={false}
                        width={1000}
                        height={20}
                      />
                    </div>
                  </div>
                </ContainerBox>
              }
              renderComponent={
                <>
                  {/* <img
                    className={styles.playIcon}
                    src={require("../../assets/images/playBtnn.png")}
                    alt=""
                  /> */}
                  <img
                    onClick={isMobileDevice ? startWatchingBtn : undefined}
                    loading="lazy"
                    src={
                      thumbnailUrl ||
                      `https://image.mux.com/${playbackid}/thumbnail.jpg${
                        tokens &&
                        tokens.thumbnailToken &&
                        tokens.thumbnailToken !== ""
                          ? `?token=${tokens.thumbnailToken}`
                          : ``
                      }`
                    }
                    alt={"videoPlaceholder"}
                    height="100%"
                    width="100%"
                  />
                  {/* <div
                    className={styles.overlayBG}
                    // onClick={startWatchingBtn}
                  ></div>
                  <div className={styles.videoOverlay}>
                    {videoData && !videoToggle && (
                      <VideoOverlayDesktop
                        startWatchingBtn={startWatchingBtn}
                        cardData={videoData}
                        startingPoint={
                          mediaMetadata[videoData.id]
                            ? mediaMetadata[videoData.id].lastWatchTimestamp
                            : 0
                        }
                      />
                    )}
                  </div> */}
                </>
              }
            />
          </div>
          <div
            className={`${styles.notesTranscriptSide} ${
              isSidePanelOpen && styles.notesTranscriptSideMobile
            } `}
            style={{
              width:
                isSidePanelOpen && !isMobileDevice
                  ? "40rem"
                  : isSidePanelOpen && isLandscape() && "30rem",
              zIndex: isSidePanelOpen && isFullScreen && 9,
            }}
          >
            {isSidePanelOpen && (
              // <><div className={styles.notesOverlay} ></div>
              <NewsAndTranscript
                targetType={ContentType2["Standalone Video"]}
                content={videoData}
                muxVideoRef={muxVideoRef}
                videoId={videoId}
                allNotes={allNotes}
                allChapters={allChapters}
                seekTo={seekTo}
              />
              // </>
            )}
            {isSidePanelOpen && (
              <div onClick={handleNoteBtn} className={styles.notesClose}>
                <img loading="lazy" src={close} alt="Close" />
              </div>
            )}
          </div>
        </div>
        <div className="desktop">
          <Shimmer
            loading={videoData === null}
            loadingComponent={
              <ContainerBox
                shimmer={false}
                style={{ backgroundColor: "transparent" }}
              >
                <div
                  className={`${styles.loaderWrapper} ${styles.playerSection}`}
                >
                  <div>
                    <Line count={2} sameWidth={false} width={400} height={20} />
                    <br />
                    <br />
                    <Box height={60} width={200} />
                  </div>
                  <Line count={2} sameWidth={false} width={500} height={20} />
                </div>
              </ContainerBox>
            }
            renderComponent={
              videoData &&
              !videoToggle && (
                <div className={styles.overlayData}>
                  <OverlayCard
                    handleInviteBtn={handleInviteBtn}
                    cardData={videoData}
                    handleShare={() => setCurrentVideoShare(videoData)}
                  />
                </div>
              )
            }
          />
        </div>

        <div className={styles.overlayDataMob}>
          <Shimmer
            loading={videoData === null}
            loadingComponent={
              <div className={styles.loaderWrapper}>
                <div>
                  <Line count={2} sameWidth={false} width={500} height={20} />
                  <br />
                  <br />
                  <Box height={60} width={200} />
                  <br />
                  <br />
                  <Line count={6} sameWidth={false} width={600} height={20} />
                </div>
              </div>
            }
            renderComponent={
              videoData &&
              !videoToggle && (
                <OverlayCardMob
                  startWatchingBtn={startWatchingBtn}
                  cardData={videoData}
                  startingPoint={
                    mediaMetadata[videoData.id]
                      ? mediaMetadata[videoData.id].lastWatchTimestamp
                      : 0
                  }
                  handleInviteBtn={handleInviteBtn}
                  handleNoteBtn={handleNoteBtn}
                  handleWatchLaterBtn={handleWatchLaterBtn}
                  isWatchLaterVideo={isWatchLaterVideo}
                  handleShare={() => setCurrentVideoShare(videoData)}
                />
              )
            }
          />
        </div>

        {user && (
          <div className={styles.contentWrapper}>
            <Shimmer
              loading={videoData === null}
              loadingComponent={
                <div
                  style={{
                    padding: "0 10%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      marginBottom: 50,
                    }}
                  >
                    <Box height={30} width={200} marginRight={100} />
                    <Box height={30} width={200} marginRight={100} />
                    <Box height={30} width={200} marginRight={100} />
                  </div>
                  {selectedTab === 1 ? (
                    !isMobileDevice ? (
                      <>
                        <Box height={480} width={330} marginRight={24} />
                        <Box height={480} width={330} />
                      </>
                    ) : (
                      <Box height={200} width={500} />
                    )
                  ) : (
                    <Line count={5} height={10} width={500} />
                  )}
                </div>
              }
              renderComponent={
                <TabComponent
                  tabFontSize="40px"
                  tabs={TABS}
                  onChangeTab={(index) => {
                    // videoData.videoType === VideoType.VIDEO_SERIES
                    //   ? history.push({
                    //       pathname: LN_PREPEND +`/video/${videoId}`,
                    //       search: `?season=${parseInt(selectedSeason) + 1}`,
                    //       hash: `#${TABS[index].label.toLowerCase()}`,
                    //     }):
                    history.push({
                      pathname: LN_PREPEND + `/video/${videoId}`,
                      search: search,
                      hash: `#${TABS[index].label.toLowerCase()}`,
                    });
                    addGAWithUserInfo(VIDEO_TABS_CLICK, {
                      label: TABS[index].label,
                    });
                    addCleverTapAnalytics(
                      SUB_TAB_CLICK_EVENT,
                      getSubtabData({
                        Section: TABS[index].label,
                        ...videoData,
                      })
                    );
                    setSelectedTab(index);
                  }}
                  activeTab={selectedTab}
                />
              }
            />
          </div>
        )}

        {showInviteModal && (
          <InviteModal
            from={ContentType2["Standalone Video"]}
            type="ott"
            details={currentVideoShare}
            handleClose={handleInviteBtnClose}
            customClass={"inviteModal"}
          />
        )}

        <div className={`${styles.sectionWrapper} ${styles.footerWrapper}`}>
          <ContactFooter zIndexZero />
        </div>
      </div>
    )
  );
};

export default memo(VideoDetails);
